import React, { useState } from 'react';
import axios from 'axios';
import img from './images/image.svg';
import styles from './InputFile.module.scss';

export default function InputFile({
  submit,
  id,
  className = '',
  btnText = 'Télécharger un fichier',
}:{
  submit: any
  id: string,
  btnText?: string,
  className?: string
}): JSX.Element {
  const [errorMessage, setErrorMessage] = useState<string | null | undefined>();
  function handleChange(selectorFiles: FileList | any) {
    if (selectorFiles && selectorFiles.length > 0) {
      const files = selectorFiles;
      setErrorMessage(null);
      const formData = new FormData();
      formData.append('file', files[0]);
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');
        const config: any = {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'multipart/form-data',
          },
        };
        axios.post(`${process.env.REACT_APP_API_URL}/files`, formData, config)
          .then((response) => {
            resolve(response.data);
            submit(response.data.file._id);
          })
          .catch((error) => {
            reject(error);
            setErrorMessage(error);
          });
      });
    }
    return null;
  }
  return (
    <div className={`${styles.container} ${className ? styles[className] : ''}`}>
      <input type="file" id={id} multiple onChange={(e : React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.files)} />
      {!className
      && (
      <label htmlFor={id} className={`${styles.btn} ${styles.secondary}`}>
        {btnText}
        {errorMessage && <p>{errorMessage}</p>}
      </label>
      )}
      {className === 'primary'
      && (
      <label htmlFor={id} className={`${styles.btn} ${styles.primary}`}>
        {btnText}
        {errorMessage && <p>{errorMessage}</p>}
      </label>
      )}
      {className === 'cover'
      && (
      <label htmlFor={id} className={`${className ? styles[className] : ''}`}>

        <h4>{btnText}</h4>
        <span>Fichier image ou vidéo</span>
        {errorMessage && <p>{errorMessage}</p>}
      </label>
      )}
      {className === 'browse'
      && (
      <label htmlFor={id} >
        <img src={img} alt="fichier" />
        <h4 className={styles.primary}>{btnText}</h4>
        {errorMessage && <p>{errorMessage}</p>}
      </label>
      )}

    </div>
  );
}
